import { reactive } from 'vue'

export const aliyunLivePlayerState = reactive({
  visible: false,
  streamName: '',
  playUrl: '',
})

export function openAliyunLivePlayer (streamName: string, playUrl: string) {
  aliyunLivePlayerState.streamName = streamName
  aliyunLivePlayerState.playUrl = playUrl
  aliyunLivePlayerState.visible = true
}

export function closeAliyunLivePlayer () {
  aliyunLivePlayerState.visible = false
  aliyunLivePlayerState.playUrl = ''
}

export function closeAliyunLivePlayerForStream (streamName: string) {
  if (aliyunLivePlayerState.streamName === streamName) {
    closeAliyunLivePlayer()
  }
}
